import React from 'react';
import { Monitor, Apple, HardDriveDownload, FolderSync, ShieldAlert } from 'lucide-react';

// 🌏 해외 계정용 에이전트 다운로드 (영문) — 설치 파일은 국내용과 동일 (역할은 계정에 따라 자동)
const AGENT_VERSION = '0.4.4';
const STORAGE_BASE = 'https://firebasestorage.googleapis.com/v0/b/dental-lab-system.firebasestorage.app/o';
const DOWNLOADS = {
    windows: `${STORAGE_BASE}/${encodeURIComponent(`agents/DentClusterAgent-Setup-${AGENT_VERSION}.exe`)}?alt=media`,
    mac: `${STORAGE_BASE}/${encodeURIComponent(`agents/DentClusterAgent-${AGENT_VERSION}.dmg`)}?alt=media`,
};

function GlobalAgentDownload() {
    const isMac = /Mac/i.test(navigator.platform);
    return (
        <div style={{ maxWidth: 760, margin: '0 auto', padding: 20 }}>
            <h1 style={{ fontSize: 22, fontWeight: 800, color: '#1E2230' }}><HardDriveDownload size={20} style={{ verticalAlign: -2 }} /> DentCluster Agent</h1>
            <p style={{ fontSize: 14, color: '#5A6072', margin: '6px 0 20px' }}>
                The Agent moves your cases automatically. Drop a case folder in — it transfers to your Korean lab with a parsed order form. Finished designs come back to your <b>Received results</b> folder on their own.
            </p>

            <div style={{ background: '#fff', border: '1px solid #E4E6EE', borderRadius: 14, padding: '26px 24px', textAlign: 'center' }}>
                <FolderSync size={30} color="#4F52C7" />
                <div style={{ fontSize: 16.5, fontWeight: 800, margin: '10px 0 16px' }}>Download & sign in with your DentCluster account</div>
                <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
                    <a href={DOWNLOADS.windows} style={{ ...S.btn, ...(isMac ? S.btnGhost : {}) }}><Monitor size={16} /> Windows (.exe)</a>
                    <a href={DOWNLOADS.mac} style={{ ...S.btn, ...(isMac ? {} : S.btnGhost) }}><Apple size={16} /> Mac (.dmg)</a>
                </div>
                <div style={{ fontSize: 12, color: '#94A3B8', marginTop: 10 }}>Version {AGENT_VERSION}</div>
            </div>

            <div style={{ background: '#fff', border: '1px solid #E4E6EE', borderRadius: 14, padding: '20px 24px', marginTop: 14 }}>
                <div style={{ fontSize: 14, fontWeight: 800, marginBottom: 10 }}>Setup (once)</div>
                <ol style={{ margin: 0, paddingLeft: 18, fontSize: 13.5, color: '#5A6072', lineHeight: 2 }}>
                    <li>Install and sign in with the same email you use here</li>
                    <li>In <b>Global Partners</b>, create a link with your connected Korean lab (they approve it)</li>
                    <li>Pick your <b>Sending folder</b> and <b>Received results</b> folder</li>
                    <li>Done — drop a case folder into the Sending folder to send your first case</li>
                </ol>
            </div>

            <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start', background: '#FDF3E3', border: '1px solid #F0DCBB', borderRadius: 10, padding: '12px 14px', marginTop: 14, fontSize: 12.5, color: '#92400E' }}>
                <ShieldAlert size={15} style={{ flexShrink: 0, marginTop: 1 }} />
                <span>Patient names never leave your PC — files travel under case numbers (GO-…). If Windows SmartScreen warns on install, choose “More info → Run anyway”. On Mac, if it says the app “is damaged”, run <code style={{ background: '#F0DCBB', padding: '1px 6px', borderRadius: 4 }}>xattr -cr "/Applications/덴클 에이전트.app"</code> in Terminal, then open again.</span>
            </div>
        </div>
    );
}

const S = {
    btn: { display: 'inline-flex', alignItems: 'center', gap: 7, padding: '11px 18px', background: '#4F52C7', color: '#fff', borderRadius: 9, fontSize: 14, fontWeight: 700, textDecoration: 'none' },
    btnGhost: { background: '#fff', color: '#5A6072', border: '1px solid #E4E6EE' },
};

export default GlobalAgentDownload;
